import {
    defineStore,
} from 'pinia'

export const useBitwardenStore = defineStore('bitwarden', {
    state: () => {
        return {
            collections: [],
            selectedCollectionId: null,
            items: [],
        }
    },
    
    getters: {
        getCollections: (state) => state.collections,
    },
    
    actions: {
        async fetchCollections() {
            return await useRequest({
                label: `fetch bitwarden collections`,
                fetch: () => $fetch('/api/bitwarden/collections', {
                    method: 'GET',
                }),
                evaluate: (data) => [...data],
                store: (collections) => this.collections = collections,
            })
        },
        
        selectCollection(collections) {
            this.selectedCollectionId = collections.length > 0
                ? collections[0].id
                : null
        },
        
        async fetchItems() {
            useRequest({
                label: `fetch bitwarden items`,
                fetch: () => $fetch('/api/bitwarden/items', {
                    method: 'GET',
                }),
                evaluate: ({ items }) => [...items],
                store: (items) => this.items = items,
            })
        },
        
        async createItem({
            name,
            username,
            password = undefined,
            fields = null,
            uris = null,
            collectionId,
        }) {
            useRequest({
                label: `create bitwarden item`,
                fetch: () => $fetch('/api/bitwarden/item', {
                    method: 'POST',
                    body: {
                        name,
                        username,
                        password,
                        fields,
                        uris,
                        collectionId,
                    },
                }),
            })
        },
        
        async sync() {
            useRequest({
                label: `sync bitwarden`,
                fetch: () => $fetch('/api/bitwarden/sync', {
                    method: 'POST',
                }),
            })
        },
    },
})
